import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AuthorizationService } from '../../authorization/authorization.service';

const FEATURE_FLAG_API_URL = '/api/pdx/v1/feature-flag';
const FEATURE_FLAG_API_URL_PUBLIC = '/api/pdx/v1/feature-flag/oidc-client/Portal';

export interface IFeatureFlagService {
  getFeatures(): Observable<IFeatures>;
}

export interface IFeature {
  name: string;
  isEnabled: boolean;
}

// Properties are optional because only enabled features will be mapped.
export interface IFeatures {
  feature_hero?: IFeature;
  new_map_explorer_api?: IFeature;
  software_delivery_release_date?: IFeature;
  mapexp_hide_parcel_usa?: IFeature;
  google_recaptcha_v2?: IFeature;
  software_entitlement_v4?: IFeature;
  software_download_selected?: IFeature;
  software_deeplink?: IFeature;
  mastercard_new_okta_url?: IFeature;
  data_entitlement_v2?: IFeature;
  hide_demo_sites?: IFeature;
  product_documentation_page?: IFeature;
  markdown_editor?: IFeature;
  hide_signup_link?: IFeature;
  qualified_js_chatbot?: IFeature;
  start_free_trial_link?: IFeature;

  // Leave this feature present for unit test purposes
  testFeature1?: IFeature;
  testFeature2?: IFeature;

  [index: string]: IFeature | undefined;
}
@Injectable({ providedIn: 'root' })
export class FeatureFlagService implements IFeatureFlagService {
  private _features$?: Observable<IFeatures>;

  constructor(
    private _httpClient: HttpClient,
    private _authService: AuthorizationService,
  ) {}

  getFeatures(): Observable<IFeatures> {
    if (!this._features$) {
      const url = this._authService.isAuthenticated ? FEATURE_FLAG_API_URL : FEATURE_FLAG_API_URL_PUBLIC;
      this._features$ = this._httpClient.get<IFeature[]>(url).pipe(
        map((featureFlags) => {
          const featuresMap: IFeatures = {};
          featureFlags?.forEach((feature: IFeature) => {
            featuresMap[feature.name] = feature;
          });
          return featuresMap;
        }),
        shareReplay(1),
      );
    }
    return this._features$;
  }
}
